var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialInsta(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-label": "Instagram",
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.998 0C3.139 0 0 3.142 0 7.002v10C0 20.861 3.142 24 7.002 24h10C20.861 24 24 20.858 24 16.998v-10C24 3.139 20.858 0 16.998 0h-10zM19 4a1 1 0 110 2 1 1 0 010-2zm-7 2c3.309 0 6 2.691 6 6s-2.691 6-6 6-6-2.691-6-6 2.691-6 6-6zm0 2a4 4 0 100 8 4 4 0 000-8z",
    fill: "#E84344"
  })));
}
export default SvgSocialInsta;